import React, { useState } from 'react';
import '../../../css/style.scss'
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import { MuiThemeProvider } from "@material-ui/core/styles/";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { themeButtons } from "../../../css/themeButtons";
import Modal from "../Modals/Modal";
import CardActions from "@material-ui/core/CardActions";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { phoneRegExp } from "../../../utils/phoneValidate";

const CardVertical = ({ toggleShow, buttons }) => {
  return (
    <Card raised={false}>
      <CardHeader title={"Ваш объект уже размещен у нас?"}/>
      <CardContent className="">
        <div className="row align-items-center">
          <div>Если ваш объект уже размещен на сайте и Вы хотите получить к нему доступ
          </div>

        </div>
      </CardContent>
      <CardActions className="d-flex justify-content-center align-items-center">
        <Button variant={"outlined"}
                className={buttons.btnWarnOutline}
                onClick={toggleShow}
        >
          <FontAwesomeIcon icon={["far", "envelope"]} className="pe-1" size="lg"/> Написать нам
        </Button>
      </CardActions>
    </Card>
  )
}
const CardHorizontal = ({ toggleShow, buttons }) => {
  return (
    <Card raised={false} className="login-card help-block horizont">
      <CardHeader title={"Ваш объект уже размещен у нас?"}/>
      <CardContent className="">
        <div className="row align-items-center">
          <div className="col-sm-9">Если ваш объект уже размещен на сайте и Вы хотите получить к нему доступ
          </div>
          <div className="col-sm-3">
            <Button variant={"outlined"}
                    className={`${buttons.btnWarnOutline} d-flex w-100 p-0 py-2 justify-content-center align-items-center`}
                    onClick={toggleShow}
            >
              <FontAwesomeIcon icon={["far", "envelope"]} className="pe-1" size="lg"/> Написать нам

            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

const ForgotAccount = ({ cardOrientation, getAccess2Object }) => {
  let [show, toggleModalShow] = useState(false);
  let [saving, setSaving] = useState(false)
  const toggleShow = () => {
    toggleModalShow(!show)
  };


  const loginSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, 'Слишком короткое имя')
      .max(50, 'Слишком длинное имя'),
    phone: Yup.string()
      .min(11, 'Введите корректный номер телефона (пример: +79999999999)')
      .max(19, 'Введите корректный номер телефона (пример: +79999999999)')
      .matches(phoneRegExp, 'Введите корректный номер телефона (пример: +79999999999)')
      .when('email', {
        is: (email) => !email || email.length === 0,
        then: Yup.string()
          .required('Обязательно для заполнения'),
        otherwise: Yup.string().nullable(),
      }),
    email: Yup.string()
      .email('Не корректный Email')
      .when('phone', {
        is: (phone) => !phone || phone.length === 0,
        then: Yup.string()
          .required('Обязательно для заполнения'),
        otherwise: Yup.string().nullable(),
      }),
    info: Yup.string()
      .required('Поле не заполнено'),
  }, [['email', 'phone']]);


  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const onSubmit = async values => {
    let res = await getAccess2Object(values)
    if (res) {
      setSaving(true)
      await sleep(3000);
      toggleShow()
      setSaving(false)
    }
  }


  const buttons = themeButtons();

  return (<>
      {cardOrientation === "vertical"
        ? <CardVertical toggleShow={toggleShow} buttons={buttons}/>
        : <CardHorizontal toggleShow={toggleShow} buttons={buttons}/>}

      {show && <Formik validationSchema={loginSchema}
                       initialValues={{ name: '', email: '', phone: '', info: '' }}
                       onSubmit={onSubmit}>
        {({ errors, touched, handleSubmit, isSubmitting }) => (
          <Form>
            <Modal toggleShow={toggleShow} btnOkAction={handleSubmit} show={show}
                   title={"Укажите необходимые данные для получения доступа в Личный кабинет:"}
                   textBtnOk={"Отправить"} disableBtnOk={isSubmitting}>

              {!saving && <><Field name="name">
                {({ field, form }) => (
                  <TextField size="small"
                             {...field}
                             type="text" variant="outlined"
                             className="w-100 mb-3"
                             label="Ваше имя"
                             error={Boolean(errors.name && touched.name)}
                             helperText={
                               touched.name && errors.name
                             }
                  />
                )}
              </Field>
                <Field name="email">
                  {({ field, form }) => (
                    <TextField size="small"
                               {...field}
                               type="text" variant="outlined"
                               className="w-100 mb-3"
                               label="Ваш Email"
                               error={Boolean(errors.email && touched.email)}
                               helperText={
                                 touched.email && errors.email
                               }
                    />
                  )}
                </Field>
                <Field name="phone">
                  {({ field, form }) => (
                    <TextField size="small"
                               {...field}
                               type="text" variant="outlined"
                               className="w-100 mb-3"
                               label="Ваш телефон"
                               error={Boolean(errors.phone && touched.phone)}
                               helperText={
                                 touched.phone && errors.phone
                               }
                    />
                  )}
                </Field>
                <Field name="info">
                  {({ field, form }) => (
                    <TextField size="small"
                               {...field}
                               type="text" variant="outlined"
                               className="w-100 mb-3"
                               label="Название, адрес или ссылка на объект"
                               error={Boolean(errors.info && touched.info)}
                               helperText={
                                 touched.info && errors.info
                               }
                    />
                  )}
                </Field>

                <Typography variant="body2" display="block" color="error">
                  Обязательно укажите Ваше имя, номер телефона и email, чтобы мы могли связаться с
                  Вами по
                  вопросам получения доступа в Личный кабинет
                </Typography>
              </>}

              {saving && <Typography variant="h6" className="text-center">Запрос на восстановление успешно
                отправлен!</Typography>}


            </Modal>
          </Form>
        )}
      </Formik>}
    </>
  )

}


export default ForgotAccount;
